export default __webpack_public_path__ + "static/media/2.a3bc03c2.jpg";